import {createSlice} from '@reduxjs/toolkit';
import {createSelector} from 'reselect';

export const appHeaderSlice = createSlice({
  name: 'appHeader',
  initialState: {
    isMenuDrawerOpen: false
  },
  reducers: {
    setIsMenuDrawerOpen: (state, action) => {
      state.isMenuDrawerOpen = action.payload;
    }
  }
});

export const {setIsMenuDrawerOpen} = appHeaderSlice.actions;

const appHeaderSelector = (state) => state.appHeader;

export const isMenuDrawerOpenSelector = createSelector(
  [appHeaderSelector],
  (appHeaderData) => appHeaderData.isMenuDrawerOpen
);

export default appHeaderSlice.reducer;
